/* eslint-disable */
export default function prototypes() {

	//
	// ─── ARRAY ──────────────────────────────────────────────────────────────────────
	//

	if (!Array.prototype.first) {
		Array.prototype.first = function () {
			return this[0];
		}
	}

	if (!Array.prototype.last) {
		Array.prototype.last = function () {
			return this[this.length - 1];
		}
	}

	if (!Array.prototype.getRandomElement) {
		Array.prototype.getRandomElement = function () {
			return this[Math.floor(Math.random() * this.length)];
		}
	}

	if (!Array.prototype.loopUp) {
		Array.prototype.loopUp = function () {
			let last = this.pop()
			this.unshift(last)
			// return this
		}
	}

	if (!Array.prototype.shuffle) {
		Array.prototype.shuffle = function () {
			var currentIndex = this.length, temporaryValue, randomIndex;
			while (0 !== currentIndex) {
				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;
				// And swap it with the current element.
				temporaryValue = this[currentIndex];
				this[currentIndex] = this[randomIndex];
				this[randomIndex] = temporaryValue;
			}
			return this
		}
	}

	if (!Array.prototype.isEmpty ) {
		Array.prototype.isEmpty = function () {
			return this.length == 0
		}
	}

	//
	// ─── OBJECT ─────────────────────────────────────────────────────────────────────
	//

	

	// if (!Object.prototype.isEmpy) {
	// 	Object.prototype.isEmpty = function() {
	// 		return Object.keys(obj).length === 0 && obj.constructor === Object
	// 	};
	// }


	//
	// ─── STRING ─────────────────────────────────────────────────────────────────────
	//

	if (!Number.prototype.normalizeDeg ) {
		Number.prototype.normalizeDeg = function () {
			let a = this
			a = a % 360
			a = (a + 360) % 360;
			return a
		}
	}
	
	if (!Number.prototype.normalizeDeg180 ) {
		Number.prototype.normalizeDeg180 = function () {
			let a = this
			a = a.normalizeDeg()
			if ( a > 180) a -= 360;
			return a
		}
	}

}



// WEBPACK FOOTER //
// ./src/kit/prototypes.js